import { getStaleThresholdLabel } from '../../charts/engine';

export function renderFooterTelemetryStrip(): string {
    const a = getStaleThresholdLabel('A');
    const b = getStaleThresholdLabel('B');
    const c = getStaleThresholdLabel('C');
    const d = getStaleThresholdLabel('D');

    return `
      <footer class="terminal-footer" aria-label="Telemetry strip">
        <span class="terminal-footer__item">STREAM: <strong id="terminal-stream-state">CONNECTING</strong></span>
        <span class="terminal-footer__item">LATENCY: <strong id="terminal-latency">--</strong></span>
        <span class="terminal-footer__item">ERR SPIKE: <strong id="terminal-error-spike">0/120s</strong></span>
        <span class="terminal-footer__item">CACHE HIT: <strong id="terminal-cache-hit">--</strong></span>
        <span class="terminal-footer__item">CACHE MISS: <strong id="terminal-cache-miss">--</strong></span>
        <span class="terminal-footer__item">CACHE ERR: <strong id="terminal-cache-errors">--</strong></span>
        <span class="terminal-footer__item">OPTIONS ALERT: <strong id="terminal-options-alert">NO ALERT</strong></span>
        <span class="terminal-footer__item">CHART BUDGET: <strong id="terminal-chart-budget">--</strong></span>
        <span class="terminal-footer__item">STALE THR: <strong>A ${a} | B ${b} | C ${c} | D ${d}</strong></span>
        <span class="terminal-footer__item">UPDATED: <strong id="terminal-telemetry-updated">--</strong></span>
      </footer>
    `;
}
